import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import useAdvanceTable from 'hooks/useAdvanceTable';
import ActionButton from 'components/common/ActionButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { removePlantedItems } from 'reducers/landDevReducer';

const DevelopDataTable = ({ errors, setError, clearErrors }) => {
  const [data, setData] = useState([]);
  const { plantingDataSource } = useSelector(state => state.landDev);
  const dispatch = useDispatch();

  const columns = [
    {
      accessorKey: 'parcel',
      header: 'Parcel'
    },
    {
      accessorKey: 'name',
      header: 'Name'
    },
    {
      accessorKey: 'numberOfItems',
      header: 'Number of Items'
    },
    {
      id: 'actions',
      header: '',
      cell: ({ row: { original } }) => {
        const { id } = original;

        return (
          <>
            <ActionButton
              icon="trash-alt"
              title="Remove"
              variant="action"
              className="p-0"
              onClick={() => dispatch(removePlantedItems(id))}
            />
          </>
        );
      }
    }
  ];

  useEffect(() => {
    setData(plantingDataSource);
    if (plantingDataSource.length === 0) {
      setError('plantingDataSource', {
        type: 'custom',
        message: 'You must plant at least one item'
      });
    } else {
      clearErrors('plantingDataSource');
    }
  }, [plantingDataSource]);

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    pagination: true,
    perPage: 4
  });

  return (
    <AdvanceTableProvider {...table}>
      <AdvanceTable
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs-10 mb-0 overflow-hidden'
        }}
        emptyMessage="No data."
      />
      <div className="mt-3">
        <AdvanceTableFooter rowInfo navButtons />
      </div>
      <Form.Control
        type="hidden"
        isInvalid={errors.selectedLandParcels}
      ></Form.Control>
      <Form.Control.Feedback type="invalid">
        {errors.selectedLandParcels?.message}
      </Form.Control.Feedback>
    </AdvanceTableProvider>
  );
};

DevelopDataTable.propTypes = {
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired
};

export default DevelopDataTable;
